import React, { useEffect, useState } from "react";
import "react-image-crop/dist/ReactCrop.css";

import { Helmet } from "react-helmet-async";
import NavbarTop from "../components/NavbarTop";
import ScreenModal from "./Layouts/ScreenModal/ScreenModal";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useMessage } from "../global-components/src";
import { errorMessage } from "../utils/TextManagerTwo";
import Spinner from "../global-components/src/components/spinner/spiner";
import { PACOCA_API_URL } from "../global-components/src/utils/vars";
import LeftPanel from "./Login/left-panel";
import { t } from "i18next";

const ForgotPassword = () => {
  const [searchParams] = useSearchParams();
  const [login, setLogin] = useState<string>("");
  const [errorsInput, setErrorsInput] = useState<{ email?: string[]; }>({});
  const [loading, setLoading] = useState(false);
  const { setMessage } = useMessage();
  const navigate = useNavigate();

  // Captura os parâmetros da URL ao carregar a página
  useEffect(() => {
    setLogin(searchParams.get("login") || "");
  }, [searchParams]);

  const handleResetPassowrd = async () => {
    setErrorsInput({})
    const lastRequestTime = localStorage.getItem("lastForgotPasswordRequest");
    const now = Date.now();
    const cooldownTime = 60 * 1000; // 1 minuto (ajuste conforme necessário)

    if (lastRequestTime && now - parseInt(lastRequestTime) < cooldownTime) {
      setMessage("Você já solicitou a redefinição de senha. Aguarde um momento antes de tentar novamente.", "warning", "Aguarde");
      return;
    }

    try {
      let errors: Record<string, string[]> = {};
      if (!login) {
        errors.email = [t("errors.input.required", { field: t("inputs.email") })];
      }

      if (Object.keys(errors).length > 0) {
        throw {
          response: {
            data: {
              errors
            }
          }
        };
      }

      setLoading(true)

      const response = await axios.post(`${PACOCA_API_URL}/forgot-password`, {
        email: login
      }, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        }
      });

      const data = response.data;
      const message = data.message || "Link de redefinição de senha enviado por email.";
      const title = data.title || null;
      const type = data.type_message || "success";
      setMessage(message, type, title)
      localStorage.setItem("lastForgotPasswordRequest", now.toString()); // Salva o tempo da última solicitação
    } catch (err: any) {
      if (err?.response?.data.errors) {
        setErrorsInput(err.response.data.errors); // Atualiza o estado com os erros
      } else {
        const messageError = errorMessage(err)
        const type = err?.response?.data?.type_message || "error";
        setMessage(messageError, type, "Erro ao enviar link de redefinição")
        console.error(messageError);
      }
      console.error('Erro:', err);
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Helmet>
        <title>Paçoca - Esqueci minha Senha</title>
        <meta name="description" content="Redefina sua senha no Paçoca, a rede social 100% brasileira" />
        <meta name="keywords" content="Paçoca, rede social, fazer amigos, conexões online, comunidade digital, rede social brasileira, criar perfil online, compartilhar momentos" />
        <meta name="author" content="Paçoca Inc." />
        <meta property="og:title" content="Paçoca - Esqueci minha Senha" />
        <meta property="og:description" content="Redefina sua senha no Paçoca, a rede social 100% brasileira." />
        <meta property="og:image" content="/img/link-preview.png?v=1" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Paçoca - Esqueci minha Senha" />
        <meta name="twitter:description" content="Redefina sua senha no Paçoca, a rede social 100% brasileira" />
        <meta name="twitter:image" content="/img/link-preview.png?v=1" />
      </Helmet>

    <div className="container-login">
      <div className="auth-layout">
        <LeftPanel />

        <div className="auth-panel-right">
          <div className="auth-logo">
              <img src="/img/pacoca-sem-braco.png" alt="Paçoca" className="auth-logo__img" />
          </div>

            <div className="auth-form" id='form-login'>
                <h1 className="auth-title">Resetar Senha</h1>
                <p className="auth-subtitle">
                  O link de redefinição de senha será enviado para o email.
                </p>

                <div className="auth-field">
                  <label className="auth-field__label" htmlFor="input-email">
                      {"Email ou nome de usuário"}
                  </label>
                  <div className="auth-field__wrap">
                      <span className="auth-field__icon">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                      </span>
                      <input
                          autoCapitalize="none"
                          placeholder={"Email ou nome de usuário"}
                          id="input-email"
                          type="email"
                          value={login}
                          onChange={(e) => setLogin(e.target.value)}
                          className={`auth-input ${errorsInput.email ? "auth-input--error" : ""}`}
                          name="email"
                          autoComplete="email"
                      />
                  </div>
                  {errorsInput.email && (
                      <span className="auth-error">{errorsInput.email[0]}</span>
                  )}
              </div>

            <div className="form-group">
              <div className="col link-criar-conta">
                  <button onClick={handleResetPassowrd} disabled={loading} className="auth-btn-primary">
                    {loading ? (
                      <>
                        <Spinner />
                      </>
                    ) : (
                      <>Enviar link por email</>
                    )}
                </button>
                {/* <Link className="link-criar-conta text" >Fazer login</Link> */}
                <div className="auth-center-link" style={{ marginTop: 12 }}>
                    <Link to="/login" className="auth-link" >
                       Fazer login
                    </Link>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
